import { render, staticRenderFns } from "./FinancialRatioItem.vue?vue&type=template&id=857a08e2&scoped=true&"
import script from "./FinancialRatioItem.vue?vue&type=script&lang=js&"
export * from "./FinancialRatioItem.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRatioItem.vue?vue&type=style&index=0&id=857a08e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a08e2",
  null
  
)

export default component.exports